import {
  HEADER_HEIGHT_IN_PIXELS,
  HEADER_HEIGHT_IN_PIXELS_MOBILE,
} from 'src/molecules/Shared/2023_Q4/Header/Header.styles';
import { applyStylesToMobileExperience } from 'src/molecules/Shared/2024_Q1_people_magic/BaseAnimatedExperienceController/BaseAnimatedExperienceController.styles';
import { StyledContainerWithScale } from 'src/styles/functions/getAnimationContainerDefaultStyles';
import styled, { css } from 'styled-components';

export const CommunityBusinessHeroBannerContainer = styled.div`
  position: relative;
  background: linear-gradient(180deg, rgba(20, 25, 33, 0) 0%, rgba(20, 25, 33, 0.56) 100%), #007d7d;
  height: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  overflow: hidden;

  ${applyStylesToMobileExperience(css`
    min-height: unset;
  `)}
`;

export const CommunityBusinessHeroBannerContent = styled(StyledContainerWithScale)`
  max-width: 1280px;
  margin: 0 auto;
  padding: calc(7rem + ${HEADER_HEIGHT_IN_PIXELS}px) 2.5rem 4.5rem;
  box-sizing: border-box;
  display: grid;
  grid-row-gap: 4.35rem;

  ${applyStylesToMobileExperience(css`
    grid-row-gap: 2.5rem;
    padding: calc(6.5rem + ${HEADER_HEIGHT_IN_PIXELS_MOBILE}px) 1.5rem 3rem;
  `)}
`;
